import { View, Text, StyleSheet } from '@react-pdf/renderer'
import React from 'react'
import QRCodeComponent from '../QRCode'

const styles = StyleSheet.create({
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 40,
    right: 40,
    borderTopWidth: 2,
    borderTopColor: '#000',
    paddingTop: 10,
    paddingBottom: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 50,
  },
  footerTextContainer: {
    flex: 1,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  footerTextBold: {
    fontWeight: 'bold',
    marginBottom: 2,
    fontSize: 9,
    color: '#000',
  },
  footerText: {
    fontSize: 9,
    color: '#000',
  },
  qrCodeContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 10,
  }
})

interface FooterOfPDFFashionProps {
  qrCodeDataUrl?: string
  qrCodeValue?: string
}

const FooterOfPDFFashion: React.FC<FooterOfPDFFashionProps> = ({ qrCodeDataUrl, qrCodeValue }) => {
  return (
    <View fixed style={styles.footer} >
      <View style={styles.footerTextContainer}>
        <Text style={styles.footerTextBold}>VEROSENSO CONFECÇÕES LTDA</Text>
        <Text style={styles.footerText}>Avenida. Maranhão, 261 | São Geraldo | 90230-041 | Porto Alegre - RS | Brasil</Text>
      </View>
      {qrCodeDataUrl && qrCodeValue && (
        <View style={styles.qrCodeContainer}>
          <QRCodeComponent qrCodeDataUrl={qrCodeDataUrl} size={50} />
        </View>
      )}
    </View>
  )
}

export default FooterOfPDFFashion

